import { useEffect } from "react";
import { getActiveLiveContent } from "../utils/shared/events";
import { useEvents } from "../context/EventsContext";

const useActiveLiveContentSync = () => {
    const { setActiveEventData } = useEvents();

    useEffect(() => {
        const handleStateUpdate = () => {
            setActiveEventData(prev => {
                const next = getActiveLiveContent() || {};
                if (prev === null) return next;
                if (prev?.id === next?.id && prev?.contentType === next?.contentType && prev?.status === next?.status) return prev;
                return next;
            });
        };

        window.addEventListener("UpshowStateUpdate", handleStateUpdate);
        return () => window.removeEventListener("UpshowStateUpdate", handleStateUpdate);
    }, [setActiveEventData]);
};

export default useActiveLiveContentSync;
